export enum Permission {
  MANAGE_GROUP = 'MANAGE_GROUP',
  MANAGE_EVENTS = 'MANAGE_EVENTS',
  APPROVE_MEMBER = 'APPROVE_MEMBER',
}

export enum ImageSize {
    Banner = 'Banner',
    Card = 'Card',
    Thumbnail = 'Thumbnail',
    Profile = 'Profile',
}

export enum ImageOwnerType {
    Organization = 'organization',
    Person = 'person',
}